// extracted by mini-css-extract-plugin
export default {"container":"Bubbles1_container__YAhzP","bubble1":"Bubbles1_bubble1__ZEZo3","bubble2":"Bubbles1_bubble2__kNTpN"};